// Maximum unique values a scoring component field may have before its unique
// list is dropped (I360G-2558). The multi-param limit can be raised per tenant
// via the MULTI_PARAM_UNIQUE_LIMIT_FLAG feature flag.
export const MULTI_PARAM_UNIQUE_LIMIT_FLAG =
	'info-360-risk-multiparam-unique-item-limit';

export const defaultMultiParamUniqueLimit = 50;
export const singleParamUniqueLimit = 100;

// Accepts the raw flag value (number or numeric string); anything that is not
// a positive integer falls back to the default.
export const getMultiParamUniqueLimit = (flagValue: unknown): number => {
	const limit =
		typeof flagValue === 'string' && flagValue.trim() !== ''
			? Number(flagValue)
			: flagValue;
	return typeof limit === 'number' && Number.isInteger(limit) && limit > 0
		? limit
		: defaultMultiParamUniqueLimit;
};
